import Header from "../components/Header";
import React, { useState } from "react";
import { Link } from "react-router-dom";

const IMAGES = {
  hero: "https://anhhqifbclbhvrbcssoe.supabase.co/storage/v1/object/public/home-page-gymplix/home01.png",
  flow1: "https://anhhqifbclbhvrbcssoe.supabase.co/storage/v1/object/public/home-page-gymplix/home02.png",
  flow2: "https://anhhqifbclbhvrbcssoe.supabase.co/storage/v1/object/public/home-page-gymplix/Home03.png",
  flow3: "https://anhhqifbclbhvrbcssoe.supabase.co/storage/v1/object/public/home-page-gymplix/home04.png",
};

export default function LandingPage() {
  return (
    <div className="min-h-screen bg-white text-gray-900">

      <Header />

      {/* HERO */}
      <section className="px-6 py-24 text-center bg-gradient-to-b from-slate-50 to-white">
        <div className="max-w-5xl mx-auto">

          <h1 className="text-4xl md:text-5xl font-bold mb-4">
            Make Your Work Faster
          </h1>

          <p className="text-xl mb-6 text-gray-700">
            A smart platform for content creators
          </p>

          <p className="text-gray-600 max-w-2xl mx-auto mb-12">
            Prepare content, create pins, and publish to Pinterest — always with your permission.
          </p>

          {/* EXPLANATION BLOCK */}
          <div className="grid grid-cols-1 md:grid-cols-3 gap-10 text-center mb-16">

            <div className="p-8 rounded-xl bg-rose-50 border border-rose-100 hover:shadow-md transition">
              <h3 className="text-xl font-semibold mb-3 text-rose-900">
                Clarity instead of chaos
              </h3>
              <p className="text-rose-800">
                Turn scattered ideas into Pinterest-ready pins with a clear structure.
              </p>
            </div>

            <div className="p-8 rounded-xl bg-emerald-50 border border-emerald-100 hover:shadow-md transition">
              <h3 className="text-xl font-semibold mb-3 text-emerald-900">
                You stay in control
              </h3>
              <p className="text-emerald-800">
                Nothing is published automatically. Every action is intentional.
              </p>
            </div>

            <div className="p-8 rounded-xl bg-amber-50 border border-amber-100 hover:shadow-md transition">
              <h3 className="text-xl font-semibold mb-3 text-amber-900">
                Work with confidence
              </h3>
              <p className="text-amber-800">
                Focus on content while the workflow stays calm and predictable.
              </p>
            </div>

          </div>

          {/* HERO IMAGE */}
          <img
            src={IMAGES.hero}
            alt="GymPlix platform overview"
            className="mx-auto rounded-xl shadow-md mb-12"
          />

          {/* CTA */}
          <div className="flex justify-center gap-4">
            <Link
              to="/login"
              className="px-6 py-3 rounded-md bg-gray-900 text-white hover:bg-gray-800 transition"
            >
              Login
            </Link>
            <Link
              to="/register"
              className="px-6 py-3 rounded-md border border-gray-300 hover:bg-gray-100 transition"
            >
              Create account
            </Link>
          </div>

        </div>
      </section>

      {/* WORKFLOW */}
      <section className="py-20 bg-slate-50">
        <div className="max-w-6xl mx-auto px-6 text-center">
          <h2 className="text-3xl font-semibold mb-16">
            Make your content workflow easier
          </h2>

          <div className="grid md:grid-cols-3 gap-8">
            <FlipCard
              src={IMAGES.flow1}
              label="Connect your website"
              description="Select content you want to prepare for Pinterest publishing."
            />
            <FlipCard
              src={IMAGES.flow2}
              label="Prepare & create pins"
              description="Create Pinterest-ready visuals with structured tools."
            />
            <FlipCard
              src={IMAGES.flow3}
              label="Publish with permission"
              description="Publish only with explicit user authorization."
            />
          </div>
        </div>
      </section>

      {/* COMPLIANCE */}
      <section className="py-16 bg-white">
        <div className="max-w-3xl mx-auto text-center px-6">
          <p className="text-gray-600">
            GymPlix uses Pinterest APIs in accordance with platform policies.
            Content is published only with explicit user authorization.
          </p>
        </div>
      </section>

      {/* BUILT BY */}
      <section className="py-12 bg-slate-50">
        <div className="max-w-3xl mx-auto text-center px-6">
          <h3 className="text-lg font-semibold mb-3 text-gray-900">
            Built by Creative Brains LTD
          </h3>
          <p className="text-gray-600 max-w-xl mx-auto">
            Creative Brains LTD builds advanced automation systems powered by Gymplix to help businesses scale faster, streamline operations, and make data-driven decisions.
          </p>
        </div>
      </section>

      {/* FOOTER */}
      <footer className="border-t py-8 text-center text-sm text-gray-500">
        <p className="mb-2">© {new Date().getFullYear()} Creative Brains LTD. All rights reserved.</p>
        <p className="mb-4 text-xs text-gray-400">Creative Brains LTD, London, United Kingdom.</p>
        <div className="flex justify-center gap-4">
          <Link to="/privacy-policy" className="underline">Privacy Policy</Link>
          <Link to="/terms" className="underline">Terms & Conditions</Link>
           <Link to="/data-deletion" className="underline">
          Data Deletion
        </Link>
          <a href="mailto:contact@gymplix.com" className="underline">Contact</a>
        </div>
      </footer>

    </div>
  );
}

/* ================= FLIP CARD ================= */

function FlipCard({ src, label, description }) {
  const [flipped, setFlipped] = useState(false);

  return (
    <div
      className="relative h-[340px] perspective cursor-pointer"
      onClick={() => setFlipped(!flipped)}
    >
      <div
        className={`absolute inset-0 rounded-xl shadow-md border border-gray-100
        transition-transform duration-500 transform-style-preserve-3d
        ${flipped ? "rotate-y-180" : ""}`}
      >
        <div className="absolute inset-0 bg-white rounded-xl p-6 backface-hidden flex flex-col items-center justify-center">
          <img src={src} alt={label} className="rounded-lg mb-4 hover:scale-105 transition" />
          <p className="font-medium">{label}</p>
        </div>

        <div className="absolute inset-0 bg-white rounded-xl p-8 backface-hidden rotate-y-180 flex items-center justify-center">
          <p className="text-lg font-semibold text-center">{description}</p>
        </div>
      </div>
    </div>
  );
}
